"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.persianNumbersCasting = exports.truncate = exports.numToIntl = exports.intlToNum = exports.returnNameOfBrowser = exports.validateString = exports.isNumber = void 0;
function isNumber(value) {
    return (value !== null &&
        value !== "" &&
        value !== undefined &&
        !isNaN(Number(value.toString())));
}
exports.isNumber = isNumber;
function validateString(value) {
    return value !== null && value !== "" && value !== undefined;
}
exports.validateString = validateString;
function returnNameOfBrowser() {
    if ((navigator.userAgent.indexOf("Opera") ||
        navigator.userAgent.indexOf("OPR")) !== -1) {
        return "Opera";
    }
    else if (navigator.userAgent.indexOf("Edg") !== -1) {
        return "Edge";
    }
    else if (navigator.userAgent.indexOf("Chrome") !== -1) {
        return "Chrome";
    }
    else if (navigator.userAgent.indexOf("Safari") !== -1) {
        return "Safari";
    }
    else if (navigator.userAgent.indexOf("Firefox") !== -1) {
        return "Firefox";
    }
    else if (navigator.userAgent.indexOf("MSIE") !== -1 ||
        !!document.designMode === true) {
        //IF IE > 10
        return "IE";
    }
    else {
        return "unknown";
    }
}
exports.returnNameOfBrowser = returnNameOfBrowser;
const intlToNum = (intl) => {
    const res = intl && intl.includes(",") ? intl.replace(/(,)/g, "") : intl;
    if (isNaN(+res))
        return undefined;
    return +res;
};
exports.intlToNum = intlToNum;
const numToIntl = (intl) => {
    return new Intl.NumberFormat("en-US").format(intl);
};
exports.numToIntl = numToIntl;
const truncate = (str, lngt) => {
    if (str && str.length > lngt) {
        return str.substring(0, lngt) + "....";
    }
    return str;
};
exports.truncate = truncate;
const persianToLaitn = {
    "۰": "0",
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
};
const persianNumbersCasting = (x) => {
    let res = "";
    for (let i = 0; i < x.length; i++) {
        if (persianToLaitn[x[i]] !== undefined) {
            res += persianToLaitn[x[i]];
        }
        else {
            throw "error in persian to number casting";
        }
    }
    return +res;
};
exports.persianNumbersCasting = persianNumbersCasting;
